import styled from "styled-components";

export const StreamInfoRoot = styled.div`
  display: flex;
  gap: 20px;
  padding-top: 20px;
`;

export const StreamInfoFields = styled.div`
  padding: 0 0 15px 0;
  width: 100%;
  margin-right: 15px;
`;
